<template>
  <div class="location-menu" :class="{inline: inline}">
    
    <div class="selected-item" v-on:click.stop="toggleDrop">
      <div v-show="inline" class="lm-globe"><img src="../../assets/img/globe.svg" width="16px" class="globe"></div>
      {{ $nippets.sites[selected] }}
    </div>
    <transition name="fade">
      <div class="selector"  v-show="viz">
        <div class="loc-item" v-on:click="goLink('uk', url)">
          <a :href="'/' + url" :class="{'router-link-exact-active': lang === 'uk'}" v-on:click.prevent>{{ $nippets.sites.uk }}</a>
        </div>
        <div v-for="item in locKeys" :key="item" class="loc-item" v-on:click="goLink(item, url)">
          <a :href="getToLink(item,url)" :class="{'router-link-exact-active': lang === item}" v-on:click.prevent>{{ $nippets.sites[item] }}</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import langs from '@/data/langs.js'
export default {
  props: {
    inline: Boolean,
    value: Boolean
  },
  data () {
    return {
      url: '',
      selected: 'uk',
      viz: false,
      locKeys: ['us','fr','cn','au','br','sx','in','de','sg','jp']
    }
  },
  computed: {
    lang () {
      return this.$store.state.lang.toLowerCase()
    }
  },
  created () {
    this.setCurrentUrl()
  },
  methods: {
    getToLink(item, url) {
      if(item === 'de') {
        return 'https://www.illustratoren.de/'
      }
      if(!url || (url === '/')) {
        return '/' + item
      }
      return '/' + item + '/' + url
    },
    goLink(item, url) {
      if(item === 'de') {
        window.location.href = 'https://www.illustratoren.de/'
        return
      }
      this.$store.commit('setLangPref', item)
      this.$store.commit('setLang', item)
      let href = this.getToLink(item, url)
      if(item === 'uk') {
        href = url
      }
      if(href === ''){
        href = '/'
      }
      if(!href.startsWith('/')){
        href = '/' + href
      }
      if(this.$route.name === 'contact') {
        href = this.handleContactPageCase(href)
      }
      window.location = href
    },
    handleContactPageCase(href) {
      let items = href.split(/\//g)
      items.pop()
      items.push(this.$store.state.lang.toLowerCase())
      items = items.join('/')
      return items
    },
    toggleDrop () {
      this.viz = !this.viz
      if(!this.viz){
        document.body.removeEventListener('click', this.closeDrop)
        this.$emit('input', false)
      }
      else {
        document.body.addEventListener('click', this.closeDrop)
        this.$emit('input', true)
      }
    },
    closeDrop () {
      this.viz = false
      document.body.removeEventListener('click', this.closeDrop)
      this.$emit('input', false)
    },
    setCurrentUrl () {
      let place = 3
      if(this.$route.params.lang) place = 4
      let locs = window.location.href.split('/')
      this.url = locs.slice(place).join('/').trim()
      if(langs.navlangs.includes(this.url)) {
        this.url = ''
      }
      this.selected = this.$store.state.lang.toLowerCase()
    }
  },
  watch: {
    '$route.path': function () {
      this.setCurrentUrl()
    },
    value () {
      this.viz = this.value
    }
  }
}
</script>

<style scoped>
.location-menu{
  position:relative;
  
}

.location-menu.inline{
  width:90%;
}

.lm-globe{
  display:inline-block;
  margin-right:3px;
}

.location-menu .selected-item{
  background-image:url('../../assets/img/maindown.svg');
  background-position:center right;
  padding-right:17px;
  background-size:11px;
  cursor:pointer;
}

.location-menu.inline .selected-item{
  width:100%;
  box-sizing: border-box;
  display:flex;
  align-items:center;
}

.location-menu .selected-item:hover{
  color:#ce0e2d;
  background-image:url('../../assets/img/maindown-red.svg');
}

.location-menu .selector{
  position:absolute;
  box-sizing:border-box;
  top:24px;
  left:50%;
  z-index:5;
  background-color:#fff;
  transform:translateX(-50%);
  box-shadow:1px 1px 5px rgba(0,0,0,0.4);
}

.location-menu.inline  .selector{
  position:static;
  transform: none;
  box-shadow:none;
  width:100%;
  box-sizing: border-box;
  padding-top:10px;
}


.location-menu .loc-item{
  padding:6px 12px;
  white-space: nowrap;
  cursor:pointer;
}


.location-menu .loc-item:hover{
  background-color:#ce0e2d;
  color:#fff;
}

.location-menu .loc-item:hover a{
  color:#fff;
}

.location-menu .loc-item .router-link-exact-active{
  color:#ce0e2d;
}
</style>